import { render, staticRenderFns } from "./ICalConnection.vue?vue&type=template&id=107d6a56&scoped=true&"
import script from "./ICalConnection.vue?vue&type=script&lang=js&"
export * from "./ICalConnection.vue?vue&type=script&lang=js&"
import style0 from "./ICalConnection.vue?vue&type=style&index=0&id=107d6a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107d6a56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107d6a56')) {
      api.createRecord('107d6a56', component.options)
    } else {
      api.reload('107d6a56', component.options)
    }
    module.hot.accept("./ICalConnection.vue?vue&type=template&id=107d6a56&scoped=true&", function () {
      api.rerender('107d6a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/Channels/ICalConnection.vue"
export default component.exports